module.exports = __webpack_public_path__ + "static/media/pay35.74cf4317.png";